import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { selectionFromUrl, selectionToUrl, type DeviceNavSelection } from './deviceNavState';

/* The selection lives in the URL, so it survives opening a device and coming Back. */
export default function useDeviceNavSelection () {
  // `search` is the URL's query string, not the device search box.
  const { pathname, search: queryString } = useLocation();
  const history = useHistory();

  const selection = useMemo(() => selectionFromUrl(queryString), [queryString]);

  const setSelection = useCallback((next: DeviceNavSelection) => {
    history.replace({ pathname, search: selectionToUrl(next, queryString) });
  }, [history, pathname, queryString]);

  return [selection, setSelection] as const;
}
